import { render, staticRenderFns } from "./indexVideo.vue?vue&type=template&id=531408b2&scoped=true"
import script from "./indexVideo.vue?vue&type=script&lang=js"
export * from "./indexVideo.vue?vue&type=script&lang=js"
import style0 from "./indexVideo.vue?vue&type=style&index=0&id=531408b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531408b2",
  null
  
)

export default component.exports